import React from "react";
import {
    FormGroup,
    Button,
    ButtonToolbar,
    HelpBlock,
    Modal,
} from 'react-bootstrap';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import { Form, Field } from 'react-final-form';
import TextEditor from "./TextEditor";
import { fetchTour } from "../../../core/api";
import { checkHttpStatus, parseJSON } from "../../../utils";
import DraftRenderer from "../../../components/DraftRenderer/DraftRenderer";

function formatNotes(notes) {
    const noteList = [];
    noteList.push(
        <div className="note">
            <DraftRenderer raw={notes} />
        </div>
        );
    return noteList;
}

class AddcityNotesModal extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            cityNotesData: []
        };
        this.handleCityNotesSubmit = this.handleCityNotesSubmit.bind(this);
        this.fetchData = this.fetchData.bind(this);
        this.showCityNotes = this.showCityNotes.bind(this);
    }
    componentWillMount() {
        this.fetchData()
    }

    fetchData() {
        fetchTour(this.props.selectedTourId)
            .then(checkHttpStatus)
            .then(parseJSON)
            .then((response) => {
                this.showCityNotes(response.city_notes)
            })
    }
    showCityNotes(city_notes) {
        const {city_id} = this.props
        const cityData = city_notes.filter(item => item.city_id === city_id)
        if(cityData && cityData.length > 0 ){
            this.setState({
                cityNotesData: cityData
         })
        }
    }
    onHideCityNotesPopUP = () => {
        this.props.onClose();
    }

    handleCityNotesSubmit(values) {
        const { city_id, city_details } = this.props
        const cityDetails = city_details.filter(item => item.id === city_id)
        const cityname = cityDetails[0].name;
        // const firstCityName = this.props.currentEvent[0].name;
        // const firstCityName = cityname.split(',')[0].trim();
        const firstCityName = this.props.currentEvent[0].place.name
        const payload = []

        payload.push({
            tour_id: this.props.selectedTourId,
            city_name: firstCityName,
            city_id: city_id,
            values: values.note_json
        })
        this.props.saveCityNotes(payload) // api for send city notes
        this.props.onClose();
    }
    removeNotes=()=>{
        const { city_id } = this.props
        this.props.DeleteEventNotes(city_id)
        this.props.onClose();
    }

    render() {
        return (
            <div>
                <Modal show={this.props.cityNotesPopUp} onHide={this.onHideCityNotesPopUP}>
                    <Modal.Header closeButton>
                        <Modal.Title>Add City Notes</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div>
                            <span>City Notes:-</span>
                            {this.state.cityNotesData.length > 0 && (
                                <div>
                                    {formatNotes(this.state.cityNotesData[0].note_json)}
                                    {/* {this.state.cityNotesData[0].note_json.blocks[0].text} */}
                                </div>
                            )}
                        </div>
                        <Form
                            onSubmit={this.handleCityNotesSubmit}
                            // initialValues={this.state.cityNotesData}
                            render={({ handleSubmit, pristine, invalid }) => (
                                <form onSubmit={handleSubmit}>
                                    <div className="container-fluid">
                                        <div className="row">
                                            <FormGroup>
                                                <Field
                                                    name="note_json"
                                                    type="textarea"
                                                    component={TextEditor}
                                                    placeholder="Lodging requests for this group. This note will be included in all tour stops."
                                                />
                                            </FormGroup>
                                            <Button bsStyle="success" type="submit" style={{ width: '16%', float: 'right' }}>
                                                Save
                                            </Button>
                                            <Button bsStyle="danger" style={{ width: '16%', float: 'right',marginRight:'5px' }} onClick={this.removeNotes} >
                                                Delete
                                            </Button>
                                        </div>
                                    </div>
                                </form>
                            )}
                        />
                    </Modal.Body>
                    <Modal.Footer style={{ clear: 'both' }} />
                </Modal>
            </div>
        )
    }
}

export default AddcityNotesModal



// WEBPACK FOOTER //
// src/routes/tours/components/AddcityNotesModal.js